/*!

=========================================================
* Black Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Home.js";
import ContactUsForm from "views/forms/ContactUsForm.js";
import RegisterWizardForm from "views/forms/RegisterWizard/RegisterWizard.js";
import QuestionsTable from "views/tables/QuestionsTable.js";
import AddQuestionForm from "views/forms/AddQuestion.js";
import EditQuestionForm from "views/forms/EditQuestion.js";

import AthletesTable from "views/tables/AthletesTable.js";
import AddAthleteForm from "views/forms/AddAthlete.js";
import EditAthleteForm from "views/forms/EditAthlete.js";

import UsersTable from "views/tables/UsersTable.js";
import AddUserForm from "views/forms/AddUserForm.js";
import EditUserForm from "views/forms/EditUserForm.js";

import CohortCollectionsTable from "views/tables/CohortCollectionsTable.js";
import AddCohortCollection from "views/forms/AddCohortCollection.js";
import EditCohortCollection from "views/forms/EditCohortCollection.js";
import CohortImagesTable from "views/tables/CohortImagesTable.js";
import AddCohortImage from "views/forms/AddCohortImage.js";
import EditCohortImage from "views/forms/EditCohortImage.js";


import TourneyCollectionsTable from "views/tables/TourneyCollectionsTable.js";
import AddTourneyCollection from "views/forms/AddTourneyCollection.js";
import EditTourneyCollection from "views/forms/EditTourneyCollection.js";
import TourneyImagesTable from "views/tables/TourneyImagesTable.js";
import AddTourneyImage from "views/forms/AddTourneyImage.js";
import EditTourneyImage from "views/forms/EditTourneyImage.js";

import GeneralCollectionsTable from "views/tables/GeneralCollectionsTable.js";
import AddGeneralCollection from "views/forms/AddGeneralCollection.js";
import EditGeneralCollection from "views/forms/EditGeneralCollection.js";
import GeneralImagesTable from "views/tables/GeneralImagesTable.js";
import AddGeneralImage from "views/forms/AddGeneralImage.js";
import EditGeneralImage from "views/forms/EditGeneralImage.js";

import EventsTable from "views/tables/EventsTable.js";
import AddEventForm from "views/forms/AddEvent.js";
import EditEventForm from "views/forms/EditEvent.js";
import AddRegistrationForm from "views/forms/AddRegistration.js";
import EditRegistrationForm from "views/forms/EditRegistration.js";
import EditRegistrationsTable from "views/tables/EditRegistrationsTable.js";
import UnprocessedRegistrationsTable from "views/tables/UnprocessedRegistrationsTable.js";
import ProcessRegistration from "views/forms/ProcessRegistration.js";
import Login from "views/pages/Login.js";

import Calendar from "views/Calendar.js";
import WaiversTable from "views/tables/WaiversTable.js";
import AddWaiverForm from "views/forms/AddWaiver.js";
import EditWaiverForm from "views/forms/EditWaiver.js";
import WaiverSubmissionsTable from "views/tables/WaiverSubmissionsTable.js";
import AllWaiverSubmissions from "views/tables/AllWaiverSubmissions.js";

import PublicWaivers from "views/pages/PublicWaivers.js";
import SubmitWaiver from "views/pages/SubmitWaiver.js";
import ViewSubmission from "views/pages/ViewSubmission.js";
import ViewAllWaiverSubmission from "views/pages/ViewAllWaiverSubmission.js";
import PreviewWaiver from "views/pages/PreviewWaiver.js";

//import ReactTables from "views/tables/ReactTables.js";
//import ValidationForms from "views/forms/ValidationForms.js";
/*
import VectorMap from "views/maps/VectorMap.js";
import GoogleMaps from "views/maps/GoogleMaps.js";
import FullScreenMap from "views/maps/FullScreenMap.js";
import ReactTables from "views/tables/ReactTables.js";
import RegularTables from "views/tables/RegularTables.js";
import ExtendedTables from "views/tables/ExtendedTables.js";
import Wizard from "views/forms/Wizard.js";
import ValidationForms from "views/forms/ValidationForms.js";
import ExtendedForms from "views/forms/ExtendedForms.js";
import RegularForms from "views/forms/RegularForms.js";
import Calendar from "views/Calendar.js";
import Widgets from "views/Widgets.js";
import Charts from "views/Charts.js";
import Dashboard from "views/Home.js";
import Buttons from "views/components/Buttons.js";
import SweetAlert from "views/components/SweetAlert.js";
import Notifications from "views/components/Notifications.js";
import Grid from "views/components/Grid.js";
import Typography from "views/components/Typography.js";
import Panels from "views/components/Panels.js";
import Icons from "views/components/Icons.js";
import Pricing from "views/pages/Pricing.js";
import Register from "views/pages/Register.js";
import Timeline from "views/pages/Timeline.js";
import User from "views/pages/User.js";
import Login from "views/pages/Login.js";
import Rtl from "views/pages/Rtl.js";
import Lock from "views/pages/Lock.js";
*/


const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    protected: false,
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-world",
    component: Dashboard,
    layout: "/admin",
  },
  {
    collapse: true,
    protected: true,
    requiredRole: 'Admin',
    invisible: true,
    name: "My Profile",
    //rtlName: "الجداول",
    icon: "tim-icons icon-paper",
    state: "profileCollapse",  //Change this once we get source done
    views: [
      {
        //path: "/regular-tables",
        name: "Manage Subscription",
        protected:true,
        requiredRole: 'Admin',
       // rtlName: "طاولات عادية",
        mini: "MS",
        //rtlMini: "صر",
        //component: RegularTables,
        layout: "/admin",
      }
    ],
  },
  {
    path: "/users",
    name: "Manage Users",
    icon: "tim-icons icon-badge",
    protected: true,
    requiredRole: 'Admin',
    component: UsersTable,
    layout: "/admin",
  },
  {
    path: "/adduser",
    name: "Add User",
    protected: true,
    invisible: true,
    component: AddUserForm,
    layout: "/admin",
  },
  {
    path: "/edituser",
    name: "Edit User",
    protected: true,
    invisible: true,
    component: EditUserForm,
    layout: "/admin",
  },
  {
    path: "/athletes",
    name: "Manage Athletes",
    icon: "tim-icons icon-user-run",
    protected: true,
    requiredRole: 'Admin',
    component: AthletesTable,
    layout: "/admin",
  },
  {
    path: "/addathlete",
    name: "Add Athlete",
    protected: true,
    invisible: true,
    component: AddAthleteForm,
    layout: "/admin",
  },
  {
    path: "/editathlete",
    name: "Edit Athlete",
    protected: true,
    invisible: true,
    component: EditAthleteForm,
    layout: "/admin",
  },
  {
    path: "/questions",
    name: "Questions",
    icon: "tim-icons icon-notes",
    protected: true,
    requiredRole: 'Admin',
    component: QuestionsTable,
    layout: "/admin",
  },
  {
    path: "/addquestion",
    name: "Add Question",
    protected: true,
    invisible: true,
    component: AddQuestionForm,
    layout: "/admin",
  },
  {
    path: "/editquestion",
    name: "Edit Question",
    protected: true,
    invisible: true,
    component: EditQuestionForm,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Waivers",
    icon: "tim-icons icon-paper",
    protected: true,
    requiredRole: ['User', 'Admin'],
    state: "waiversCollapse",
    views: [
      {
        path: "/waivers",
        name: "Manage Waivers",
        protected: true,
        mini: "MW",
        component: WaiversTable,
        layout: "/admin",
      },
      {
        path: "/allwaiversubmissions",
        name: "Search All Waivers",
        protected: true,
        mini: "SA",
        component: AllWaiverSubmissions,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/addwaiver",
    name: "Add Waiver",
    protected: true,
    invisible: true,
    component: AddWaiverForm,
    layout: "/admin",
  },
  {
    path: "/editwaiver/:id",
    name: "Edit Waiver",
    protected: true,
    invisible: true,
    component: EditWaiverForm,
    layout: "/admin",
  },
  {
    path: "/previewwaiver/:id",
    name: "Preview Waiver",
    protected: true,
    invisible: true,
    component: PreviewWaiver,
    layout: "/admin",
  },
  {
    path: "/waiversubmissions/:waiverId",
    name: "Waiver Submissions",
    protected: true,
    invisible: true,
    component: WaiverSubmissionsTable,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Events",
    icon: "tim-icons icon-trophy",
    protected: true,
    requiredRole: 'Admin',
    state: "eventsCollapse",
    views: [
      {
        path: "/events",
        name: "Manage Events",
        protected: true,
        mini: "ME",
        component: EventsTable,
        layout: "/admin",
      },
      {
        path: "/unprocessedregistrations",
        name: "Manage Registrations",
        protected: true,
        mini: "MR",
        component: UnprocessedRegistrationsTable,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/addevent",
    name: "Add Event",
    protected: true,
    invisible: true,
    component: AddEventForm,
    layout: "/admin",
  },
  {
    path: "/editevent/:id",
    name: "Edit Event",
    protected: true,
    invisible: true,
    component: EditEventForm,
    layout: "/admin",
  },
  {
    path: "/addregistration/:id",
    name: "Add Registration",
    protected: true,
    invisible: true,
    component: AddRegistrationForm,
    layout: "/admin",
  },
  {
    path: "/editregistrations/:id",
    name: "Edit Registrations",
    protected: true,
    invisible: true,
    component: EditRegistrationsTable,
    layout: "/admin",
  },
  {
    path: "/editregistration/:id",
    name: "Edit Registration",
    protected: true,
    invisible: true,
    component: EditRegistrationForm,
    layout: "/admin",
  },
  {
    path: "/processregistration/:id",
    name: "Process Registration",
    protected: true,
    invisible: true,
    component: ProcessRegistration,
    layout: "/admin",
  },
  {
    path: "/calendar",
    name: "Manage Calendars",
    icon: "tim-icons icon-calendar-60",
    protected: true,
    requiredRole: 'Admin',
    component: Calendar,
    layout: "/admin",
  },
  {
    path: "/cohortcollections",
    name: "Cohort Gallery",
    icon: "tim-icons icon-image-02",
    protected: true,
    requiredRole: 'Admin',
    component: CohortCollectionsTable,
    layout: "/admin",
  },
  {
    path: "/addcohortcollection",
    name: "Add Cohort Collection",
    protected: true,
    invisible: true,
    component: AddCohortCollection,
    layout: "/admin",
  },
  {
    path: "/editcohortcollection",
    name: "Edit Cohort Collection",
    protected: true,
    invisible: true,
    component: EditCohortCollection,
    layout: "/admin",
  },
  {
    path: "/editcohortimages/:collectionId",
    name: "Edit Cohort Images",
    protected: true,
    invisible: true,
    component: CohortImagesTable,
    layout: "/admin",
  },
  {
    path: "/addcohortimage/:collectionId",
    name: "Add Cohort Image",
    protected: true,
    invisible: true,
    component: AddCohortImage,
    layout: "/admin",
  },
  {
    path: "/editcohortimage/:collectionId",
    name: "Edit Cohort Image",
    protected: true,
    invisible: true,
    component: EditCohortImage,
    layout: "/admin",
  },
  {
    path: "/tourneycollections",
    name: "Tourney Gallery",
    icon: "tim-icons icon-image-02",
    protected: true,
    requiredRole: 'Admin',
    component: TourneyCollectionsTable,
    layout: "/admin",
  },
  {
    path: "/addtourneycollection",
    name: "Add Tourney Collection",
    protected: true,
    invisible: true,
    component: AddTourneyCollection,
    layout: "/admin",
  },
  {
    path: "/edittourneycollection",
    name: "Edit Tourney Collection",
    protected: true,
    invisible: true,
    component: EditTourneyCollection,
    layout: "/admin",
  },
  {
    path: "/edittourneyimages/:collectionId",
    name: "Edit Tourney Images",
    protected: true,
    invisible: true,
    component: TourneyImagesTable,
    layout: "/admin",
  },
  {
    path: "/addtourneyimage/:collectionId",
    name: "Add Tourney Image",
    protected: true,
    invisible: true,
    component: AddTourneyImage,
    layout: "/admin",
  },
  {
    path: "/edittourneyimage/:collectionId",
    name: "Edit Tourney Image",
    protected: true,
    invisible: true,
    component: EditTourneyImage,
    layout: "/admin",
  },
  {
    path: "/generalcollections",
    name: "General Gallery",
    icon: "tim-icons icon-image-02",
    protected: true,
    requiredRole: 'Admin',
    component: GeneralCollectionsTable,
    layout: "/admin",
  },
  {
    path: "/addgeneralcollection",
    name: "Add General Collection",
    protected: true,
    invisible: true,
    component: AddGeneralCollection,
    layout: "/admin",
  },
  {
    path: "/editgeneralcollection",
    name: "Edit General Collection",
    protected: true,
    invisible: true,
    component: EditGeneralCollection,
    layout: "/admin",
  },
  {
    path: "/editgeneralimages/:collectionId",
    name: "Edit General Images",
    protected: true,
    invisible: true,
    component: GeneralImagesTable,
    layout: "/admin",
  },
  {
    path: "/addgeneralimage/:collectionId",
    name: "Add General Image",
    protected: true,
    invisible: true,
    component: AddGeneralImage,
    layout: "/admin",
  },
  {
    path: "/editgeneralimage/:collectionId",
    name: "Edit General Image",
    protected: true,
    invisible: true,
    component: EditGeneralImage,
    layout: "/admin",
  },
  {
    path: "/register",
    name: "Register",
    protected: false,
    //rtlName: "لوحة القيادة",
    icon: "tim-icons icon-notes",
    component: RegisterWizardForm,
    layout: "/admin",
  },
  {
    path: "/signwaiver",
    name: "Sign Our Waiver",
    protected: false,
    icon: "tim-icons icon-pencil",
    component: PublicWaivers,
    layout: "/admin",
  },
  {
    path: "/submitwaiver/:id",
    name: "Submit Waiver",
    protected: false,
    invisible: true,
    component: SubmitWaiver,
    layout: "/admin",
  },
  {
    path: "/viewsubmission/:id",
    name: "View Submission",
    protected: true,
    invisible: true,
    component: ViewSubmission,
    layout: "/admin",
  },
  {
    path: "/viewallwaiversubmission/:id",
    name: "View All Waiver Submission",
    protected: true,
    invisible: true,
    component: ViewAllWaiverSubmission,
    layout: "/admin",
  },
  {
    path: "/contactus",
    name: "Contact Us",
    protected: false,
    //rtlName: "لوحة القيادة",
    icon: "tim-icons icon-email-85",
    component: ContactUsForm,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    protected: false,
    invisible: true,
    component: Login,
    layout: "/auth",
  }
    /*
  {
    collapse: true,
    name: "Pages",
    rtlName: "صفحات",
    icon: "tim-icons icon-image-02",
    state: "pagesCollapse",
    views: [
      {
        path: "/pricing",
        name: "Pricing",
        rtlName: "عالتسعير",
        mini: "P",
        rtlMini: "ع",
        component: Pricing,
        layout: "/auth",
      },
      {
        path: "/rtl-support",
        name: "RTL Support",
        rtlName: "صودعم رتل",
        mini: "RS",
        rtlMini: "صو",
        component: Rtl,
        layout: "/rtl",
      },
      {
        path: "/timeline",
        name: "Timeline",
        rtlName: "تيالجدول الزمني",
        mini: "T",
        rtlMini: "تي",
        component: Timeline,
        layout: "/admin",
      },
      {
        path: "/login",
        name: "Login",
        rtlName: "هعذاتسجيل الدخول",
        mini: "L",
        rtlMini: "هعذا",
        component: Login,
        layout: "/auth",
      },
      {
        path: "/register",
        name: "Register",
        rtlName: "تسجيل",
        mini: "R",
        rtlMini: "صع",
        component: Register,
        layout: "/auth",
      },
      {
        path: "/lock-screen",
        name: "Lock Screen",
        rtlName: "اقفل الشاشة",
        mini: "LS",
        rtlMini: "هذاع",
        component: Lock,
        layout: "/auth",
      },
      {
        path: "/user-profile",
        name: "User Profile",
        rtlName: "ملف تعريفي للمستخدم",
        mini: "UP",
        rtlMini: "شع",
        component: User,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "Components",
    rtlName: "المكونات",
    icon: "tim-icons icon-molecule-40",
    state: "componentsCollapse",
    views: [
      {
        collapse: true,
        name: "Multi Level Collapse",
        rtlName: "انهيار متعدد المستويات",
        mini: "MLT",
        rtlMini: "ر",
        state: "multiCollapse",
        views: [
          {
            path: "/buttons",
            name: "Buttons",
            rtlName: "وصفت",
            mini: "B",
            rtlMini: "ب",
            component: Buttons,
            layout: "/admin",
          },
        ],
      },
      {
        path: "/buttons",
        name: "Buttons",
        rtlName: "وصفت",
        mini: "B",
        rtlMini: "ب",
        component: Buttons,
        layout: "/admin",
      },
      {
        path: "/grid-system",
        name: "Grid System",
        rtlName: "نظام الشبكة",
        mini: "GS",
        rtlMini: "زو",
        component: Grid,
        layout: "/admin",
      },
      {
        path: "/panels",
        name: "Panels",
        rtlName: "لوحات",
        mini: "P",
        rtlMini: "ع",
        component: Panels,
        layout: "/admin",
      },
      {
        path: "/sweet-alert",
        name: "Sweet Alert",
        rtlName: "الحلو تنبيه",
        mini: "SA",
        rtlMini: "ومن",
        component: SweetAlert,
        layout: "/admin",
      },
      {
        path: "/notifications",
        name: "Notifications",
        rtlName: "إخطارات",
        mini: "N",
        rtlMini: "ن",
        component: Notifications,
        layout: "/admin",
      },
      {
        path: "/icons",
        name: "Icons",
        rtlName: "الرموز",
        mini: "I",
        rtlMini: "و",
        component: Icons,
        layout: "/admin",
      },
      {
        path: "/typography",
        name: "Typography",
        rtlName: "طباعة",
        mini: "T",
        rtlMini: "ر",
        component: Typography,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "Forms",
    rtlName: "إستمارات",
    icon: "tim-icons icon-notes",
    state: "formsCollapse",
    views: [
      {
        path: "/regular-forms",
        name: "Regular Forms",
        rtlName: "أشكال عادية",
        mini: "RF",
        rtlMini: "صو",
        component: RegularForms,
        layout: "/admin",
      },
      {
        path: "/extended-forms",
        name: "Extended Forms",
        rtlName: "نماذج موسعة",
        mini: "EF",
        rtlMini: "هوو",
        component: ExtendedForms,
        layout: "/admin",
      },
      {
        path: "/validation-forms",
        name: "Validation Forms",
        rtlName: "نماذج التحقق من الصحة",
        mini: "VF",
        rtlMini: "تو",
        component: ValidationForms,
        layout: "/admin",
      },
      {
        path: "/wizard",
        name: "Wizard",
        rtlName: "ساحر",
        mini: "W",
        rtlMini: "ث",
        component: Wizard,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "Tables",
    rtlName: "الجداول",
    icon: "tim-icons icon-puzzle-10",
    state: "tablesCollapse",
    views: [
      {
        path: "/regular-tables",
        name: "Regular Tables",
        rtlName: "طاولات عادية",
        mini: "RT",
        rtlMini: "صر",
        component: RegularTables,
        layout: "/admin",
      },
      {
        path: "/extended-tables",
        name: "Extended Tables",
        rtlName: "جداول ممتدة",
        mini: "ET",
        rtlMini: "هور",
        component: ExtendedTables,
        layout: "/admin",
      },
      {
        path: "/react-tables",
        name: "React Tables",
        rtlName: "رد فعل الطاولة",
        mini: "RT",
        rtlMini: "در",
        component: ReactTables,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "Maps",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    state: "mapsCollapse",
    views: [
      {
        path: "/google-maps",
        name: "Google Maps",
        rtlName: "خرائط جوجل",
        mini: "GM",
        rtlMini: "زم",
        component: GoogleMaps,
        layout: "/admin",
      },
      {
        path: "/full-screen-map",
        name: "Full Screen Map",
        rtlName: "خريطة كاملة الشاشة",
        mini: "FSM",
        rtlMini: "ووم",
        component: FullScreenMap,
        layout: "/admin",
      },
      {
        path: "/vector-map",
        name: "Vector Map",
        rtlName: "خريطة المتجه",
        mini: "VM",
        rtlMini: "تم",
        component: VectorMap,
        layout: "/admin",
      },
    ],
  },
  {
    path: "/widgets",
    name: "Widgets",
    rtlName: "الحاجيات",
    icon: "tim-icons icon-settings",
    component: Widgets,
    layout: "/admin",
  },
  {
    path: "/charts",
    name: "Charts",
    rtlName: "الرسوم البيانية",
    icon: "tim-icons icon-chart-bar-32",
    component: Charts,
    layout: "/admin",
  },
  {
    path: "/calendar",
    name: "Calendar",
    rtlName: "التقويم",
    icon: "tim-icons icon-time-alarm",
    component: Calendar,
    layout: "/admin",
  },*/
];

export default routes;
